import { PhysicianNameCol, PhysicianNpiCol, SelectPhysicianBtn } from "../components/styles/styles";
import { colors } from "../styles/colors";
import fontWeight from "../styles/mui/fontWeight";
import { TableBody, TableHead } from "./FormComponents";

export enum PatientTabDispatchTypes {
  PATIENT_TAB_FAIL = "PATIENT_TAB_FAIL",
  PATIENT_TAB_INVOKE = "PATIENT_TAB_INVOKE",
  PATIENT_TAB_SUCCESS = "PATIENT_TAB_SUCCESS",
}

export enum TableDropdown {
  SERVICE_PROVIDER = "SERVICE_PROVIDER",
  PHYSICIAN = "PHYSICIAN",
}

const gridSize = [4, 2, 4, 2];

const physicianTableHeadKeys = [
  "physicianName",
  "physicianNpi",
  "physicianAddress",
  "action",
];

const physicianTableBodyKeys = [
  "name",
  "npiId",
  "address",
  "CHOOSE",
];

const serviceProviderTableHeadKeys = [
  "providerName",
  "providerNpi",
  "physicianAddress",
  "action",
];

const serviceProviderTableBodyKeys = [
  "providerName",
  "providerNpi",
  "providerAddress",
  "CHOOSE",
];

export const fieldNames = [
  "primaryPhysician.physicianName",
  "primaryPhysician.physicianNpiId",
  "primaryPhysician.phoneNo",
  "primaryPhysician.streetName1",
  "primaryPhysician.county",
  "primaryPhysician.zipCode",
  "primaryPhysician.taxId",
  "primaryPhysician.fax",
  "primaryPhysician.streetName2",
  "primaryPhysician.physicianState",
  "primaryPhysician.city",
];

const tableHead: TableHead[] = [
  {
    label: "Name:",
    key: "",
    style: { textAlign: "left", paddingLeft: "1rem" },
    type: "body1",
    color: colors.black[14],
    fontWeight: fontWeight[5],
    xs: gridSize[0],
  },
  {
    label: "NPI Number:",
    key: "",
    style: { textAlign: "center" },
    type: "body1",
    color: colors.black[14],
    fontWeight: fontWeight[5],
    xs: gridSize[1],
  },
  {
    label: "Address:",
    key: "",
    style: { textAlign: "left", paddingLeft: "1rem" },
    type: "body1",
    color: colors.black[14],
    fontWeight: fontWeight[5],
    xs: gridSize[2],
  },
  {
    label: "Action:",
    key: "",
    style: { textAlign: "center" },
    type: "body1",
    color: colors.black[14],
    fontWeight: fontWeight[5],
    xs: gridSize[3],
  },
];

const tableBody: TableBody[] = [
  {
    key: "",
    style: PhysicianNameCol,
    type: "subtitle2",
    color: colors.black[4],
    fontWeight: fontWeight[4],
    xs: gridSize[0],
  },
  {
    key: "",
    style: PhysicianNpiCol,
    type: "subtitle2",
    color: colors.black[4],
    fontWeight: fontWeight[4],
    xs: gridSize[1],
  },
  {
    key: "",
    style: PhysicianNameCol,
    type: "subtitle2",
    color: colors.black[4],
    fontWeight: fontWeight[4],
    xs: gridSize[2],
  },
  {
    key: "",
    style: SelectPhysicianBtn,
    type: "subtitle2",
    color: colors.black[4],
    fontWeight: fontWeight[4],
    xs: gridSize[3],
  },
];

export const getTableHead = (table: TableDropdown) => {
  switch (table) {
    case TableDropdown.SERVICE_PROVIDER:
      return tableHead.map((head, index) => {
        head.key = serviceProviderTableHeadKeys[index];
        return head;
      });
    case TableDropdown.PHYSICIAN:
      return tableHead.map((head, index) => {
        head.key = physicianTableHeadKeys[index];
        return head;
      });
  }
  return [];
};

export const getTableBody = (tab: TableDropdown) => {
  switch (tab) {
    case TableDropdown.SERVICE_PROVIDER:
      return tableBody.map((body, index) => {
        body.key = serviceProviderTableBodyKeys[index];
        return body;
      });
    case TableDropdown.PHYSICIAN:
      return tableBody.map((body, index) => {
        body.key = physicianTableBodyKeys[index];
        return body;
      });
  }
  return [];
};

